module.exports = __webpack_public_path__ + "static/media/circo2024_palhacos.2cdeee15.webp";